// src/pages/AccountPage.js
import React, { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../context/LanguageContext";
import { useNavigate } from "react-router-dom";
import { getMe } from "../services/users.api";
import { getMyOrders } from "../services/orders.api";

function AccountPage() {
  const { lang } = useContext(LanguageContext);
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [lastOrder, setLastOrder] = useState(null);

  useEffect(() => {
  async function load() {
    try {
      const data = await getMe();
      const rawPhone = data.phone || "";
const rawEmail = data.email || "";

const phoneLooksLikeEmail = rawPhone.includes("@");

setUser({
  ...data,
  phone: phoneLooksLikeEmail ? "" : rawPhone,
  email: rawEmail || (phoneLooksLikeEmail ? rawPhone : ""),
});

      localStorage.setItem("esill-user", JSON.stringify(data)); // cache

       const orders = await getMyOrders();
      if (orders.length) {
        setLastOrder(orders[0]); // ✅ LAST ORDER
         }
    } catch {
      setUser(null);
    }
  }
  load();
}, []);

  const TEXT = {
    EN: {
      title: "MY ACCOUNT",
      back: "×",
      noUser: "No account found. Create your profile to continue.",
      create: "Create Account",
      details: "Account Details",
      edit: "Edit Profile",
      name: "Full Name",
      phone: "Phone Number",
      email: "Email",
      city: "City",
      address: "Address",
      noEmail: "No email saved",
      lastOrder: "Last Order",
      noOrder: "You have no recent orders.",
      status: "Order Status",
      delivered: "Delivered",
      pending: "Pending",
      myOrders: "My Orders",
    },
    AR: {
      title: "حسابي",
      back: "×",
      noUser: "لا يوجد حساب بعد. قومي بإنشاء حساب للمتابعة.",
      create: "إنشاء حساب",
      details: "بيانات الحساب",
      edit: "تعديل الملف",
      name: "الاسم الكامل",
      phone: "رقم الهاتف",
      email: "البريد الإلكتروني",
      city: "المدينة",
      address: "العنوان",
      noEmail: "لا يوجد بريد إلكتروني محفوظ",
      lastOrder: "آخر طلب",
      noOrder: "لا يوجد طلبات حديثة.",
      status: "حالة الطلب",
      delivered: "تم التوصيل",
      pending: "قيد التجهيز",
      myOrders: "طلباتي",
    },
  };

  const t = TEXT[lang];

  const orderStatus = lastOrder?.status;

  return (
    <div
      className="w-full min-h-screen bg-white pt-[95px] px-5 pb-24"
      dir={lang === "AR" ? "rtl" : "ltr"}
    >

      {/* BACK BUTTON */}
      <button
        onClick={() => navigate("/")}
        className="absolute top-[80px] left-4 text-3xl opacity-60 hover:opacity-100"
      >
        {t.back}
      </button>

      {/* TITLE */}
      <h1 className="text-xl font-semibold text-center">{t.title}</h1>
      <div className="h-[2px] w-16 bg-black mx-auto mt-2 mb-6"></div>

      {/* NO ACCOUNT SECTION */}
      {!user && (
        <div className="text-center mt-16">
          <p className="text-[#7A7674] mb-4">{t.noUser}</p>
          <button
            onClick={() => navigate("/create-account")}
            className="px-6 py-3 bg-black text-white rounded-md font-semibold"
          >
            {t.create}
          </button>
          <div>
          </div>
        </div>
      )}

      {/* ACCOUNT EXISTS */}
      {user && (
        <div className="w-full max-w-xl mx-auto space-y-8">

          {/* 1️⃣ ACCOUNT DETAILS */}
          <div className="border border-[#E6D8D2] rounded-lg p-5 shadow-sm bg-white">
            <div className="flex justify-between items-center mb-4">
              <h2 className="font-semibold text-lg">{t.details}</h2>
              <button
            onClick={() => navigate("/edit-profile")}
            className="
               px-4 py-[6px]
                        text-xs font-semibold 
               border border-black 
               rounded-full 
               hover:bg-black hover:text-white
               transition-all duration-200
            "
           >
            {t.edit}
           </button>

            </div>

            <div className="checkout-line"><span>{t.name}</span><span>{user.full_name}</span></div>
            <div className="checkout-line"><span>{t.phone}</span><span>{user.phone}</span></div>
            <div className="checkout-line"><span>{t.email}</span><span>{user.email || t.noEmail}</span></div>
            <div className="checkout-line"><span>{t.city}</span><span>{user.city}</span></div>
            <div className="checkout-line"><span>{t.address}</span><span>{user.address}</span></div>
          </div>

          {/* 2️⃣ LAST ORDER */}
          <div className="border border-[#E6D8D2] rounded-lg p-5 shadow-sm bg-white">
            <h2 className="font-semibold text-lg mb-4">{t.lastOrder}</h2>

            {!lastOrder && <p className="text-sm text-[#7A7674]">{t.noOrder}</p>}

            {lastOrder && (
  <div
    onClick={() => navigate("/orders")}
    className="cursor-pointer space-y-2"
  >
    <div className="checkout-line">
      <span>Order #</span>
      <span>{lastOrder.order_number}</span>
    </div>

    <div className="checkout-line">
      <span>{t.status}</span>
      <span className="capitalize text-red-600">{lastOrder.status}</span>
    </div>

    <div className="checkout-line">
      <span>Items</span>
      <span>
        {lastOrder.items
          .map((it) =>
            lang === "EN"
              ? `${it.product_name_en} x${it.qty}`
              : `${it.product_name_ar} x${it.qty}`
          )
          .join(", ")}
      </span>
    </div>

    <div className="checkout-line">
      <span>Date</span>
      <span>{new Date(lastOrder.created_at).toLocaleDateString()}</span>
    </div>
  </div>
)}

          </div>

          {/* 3️⃣ MY ORDERS BUTTON */}
          <button
            onClick={() => navigate("/orders")}
            className="w-full py-3 bg-black text-white rounded-md text-lg font-semibold hover:bg-[#222]"
          >
            {t.myOrders}
          </button>
          <button
  onClick={() => navigate("/contact")}
  className="w-full py-3 border border-black rounded-md text-sm font-semibold"
>
  {lang === "EN" ? "Support / Messages" : "الدعم والرسائل"}
</button>

        </div>
      )}
    </div>
  );
}

export default AccountPage;